import type { PortfolioMetricsDto } from '../../lib/api/endpoints';
import { formatCurrency } from '../../lib/format/currency';

import { MetricCard } from './MetricCard';

interface KeyMetricsStripProps {
  metrics: PortfolioMetricsDto | null | undefined;
  currency: string;
}

function pnlTone(value: string | undefined): 'danger' | 'neutral' | 'success' {
  if (value === undefined || Number(value) === 0) return 'neutral';
  return Number(value) > 0 ? 'success' : 'danger';
}

export function KeyMetricsStrip({ currency, metrics }: KeyMetricsStripProps) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <MetricCard
        label="Day P&L"
        tone={pnlTone(metrics?.dayPnl)}
        value={formatCurrency(metrics?.dayPnl, currency)}
      />
      <MetricCard
        label="Week P&L"
        tone={pnlTone(metrics?.weekPnl)}
        value={formatCurrency(metrics?.weekPnl, currency)}
      />
      <MetricCard
        label="Drawdown"
        value={metrics ? `${(metrics.drawdownPct * 100).toFixed(1)}%` : '—'}
        delta={`Peak ${formatCurrency(metrics?.peakNav, currency)}`}
      />
    </div>
  );
}
